import axios from "axios";

const URL_TEST = false; //false para desarrollo, true para produccion

//Url base produccion
const DEFAULT_URL = (URL_TEST) ? "https://apiappplg.xiomisystem.com/api" : "https://apipruebasapp.paseolagaleria.com.py/api";

// Optional override so the CRM can be pointed at another backend (e.g. a local one)
const URL = process.env.REACT_APP_API_URL || DEFAULT_URL;

export const VERSION_WEB = "1.0.7";

//------------------------------------------------------------------------------servicio de login
export const postLogin = (body) => {

    return new Promise((resolve, reject) => {
        axios({
            url: URL + '/usuario/auth',
            method: 'Post',
            data: body,
            headers: {
                'Content-Type': 'application/json',
            }
        })
            .then(response => {
                resolve(response.data);
            })
            .catch(error => {
                reject(error.response.data);
            })

    });
};


//------------------------------------------------------------------------------crear encuesta
export const postAddEncuesta = (body, token) => {

    return new Promise((resolve, reject) => {
        axios({
            url: URL + '/store/encuesta',
            method: 'Post',
            data: body,
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + token,
            }
        })
            .then(response => {
                resolve(response.data);
            })
            .catch(error => {
                reject(error.response.data);
            })

    });
};


//------------------------------------------------------------------------------Obtener encuestas
export const getListarEncuestas = (token, body) => {

    return new Promise((resolve, reject) => {
        axios({
            // url: URL + '/listar/encuestas',
            //   url: URL + `/filtrar/evento?titulo=${body.titulo}&estado=${body.estado}&page=${body.page}&per_page=${body.per_page}`,
            url: URL + `/listar/encuestas?titulo=${body.titulo}&estado=${body.estado}&page=${body.page}&per_page=${body.per_page}`,
            method: 'Get',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + token,
            }
        })
            .then(response => {
                resolve(response?.data);
            })
            .catch(error => {
                reject(error.response.data);
            })

    });
};

//------------------------------------------------------------------------------Obtener detalle de encuesta
export const getDetalleEncuesta = (id, token) => {

    return new Promise((resolve, reject) => {
        axios({
            url: URL + `/obtener/${id}/encuesta`,
            method: 'Get',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + token,
            }
        })
            .then(response => {
                resolve(response?.data);
            })
            .catch(error => {
                reject(error.response.data);
            })

    });
};

//------------------------------------------------------------------------------update encuesta
export const postUpdateEncuesta = (id, body, token) => {

    return new Promise((resolve, reject) => {
        axios({
            url: URL + `/update/${id}/encuesta`,
            method: 'Post',
            data: body,
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + token,
            }
        })
            .then(response => {
                resolve(response?.data);
            })
            .catch(error => {
                reject(error.response.data);
            })

    });
};

//------------------------------------------------------------------------------Obtener encuestas
export const postEncuestaReporte = (token, body) => {

    return new Promise((resolve, reject) => {
        axios({
            url: URL + `/encuestas/export`,
            method: 'Post',
            data: body,
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + token,
            }
        })
            .then(response => {
                resolve(response?.data);
            })
            .catch(error => {
                reject(error.response.data);
            })

    });
};



//------------------------------------------------------------------------------Obtener eventos
export const getListarEventos = (token) => {

    return new Promise((resolve, reject) => {
        axios({
            url: URL + '/listar/eventos',
            method: 'Get',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + token,
            }
        })
            .then(response => {
                resolve(response?.data);
            })
            .catch(error => {
                reject(error.response.data);
            })

    });
};

//------------------------------------------------------------------------------sortear
export const postSortear = (token, body, id) => {

    return new Promise((resolve, reject) => {
        axios({
            url: URL + `/sorteos/${id}/sortear`,
            method: 'Post',
            data: body,
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + token,
            }
        })
            .then(response => {
                resolve(response?.data);
            })
            .catch(error => {
                reject(error.response.data);
            })

    });
};

//------------------------------------------------------------------------------guardar ganador sorteo
export const postGuardarGanadorSorteo = (token, body, id) => {

    return new Promise((resolve, reject) => {
        axios({
            url: URL + `/sorteos/${id}/guardar-ganador`,
            method: 'Post',
            data: body,
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + token,
            }
        })
            .then(response => {
                resolve(response?.data);
            })
            .catch(error => {
                reject(error.response.data);
            })

    });
};

//------------------------------------------------------------------------------Obtener resumen sorteo
export const getResumenSorteo = (id, token) => {

    return new Promise((resolve, reject) => {
        axios({
            url: URL + `/sorteos/${id}/resumen-sorteo`,
            method: 'Get',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + token,
            }
        })
            .then(response => {
                resolve(response?.data);
            })
            .catch(error => {
                reject(error.response.data);
            })

    });
};

//------------------------------------------------------------------------------Obtener detalle sorteo
export const getDetalleSorteo = (id, token) => {

    return new Promise((resolve, reject) => {
        axios({
            url: URL + `/obtener/${id}/sorteo`,
            method: 'Get',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + token,
            }
        })
            .then(response => {
                resolve(response?.data);
            })
            .catch(error => {
                reject(error.response.data);
            })

    });
};

//------------------------------------------------------------------------------Obtener eventos
export const getDetalleEvento = (id, token) => {

    return new Promise((resolve, reject) => {
        axios({
            url: URL + `/obtener/${id}/evento`,
            method: 'Get',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + token,
            }
        })
            .then(response => {
                resolve(response?.data);
            })
            .catch(error => {
                reject(error.response.data);
            })

    });
};




//------------------------------------------------------------------------------Obtener detalle del local
export const getDetalleLocalPaginado = (token, body) => {

    return new Promise((resolve, reject) => {
        axios({
            url: URL + `/obtener/${body?.id}/local?per_page=${body?.per_page}&page=${body?.page}`,
            method: 'Get',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + token,
            }
        })
            .then(response => {
                resolve(response?.data);
            })
            .catch(error => {
                reject(error.response.data);
            })

    });
};

//------------------------------------------------------------------------------Obtener detalle del local
export const getDetalleLocal = (id, token) => {

    return new Promise((resolve, reject) => {
        axios({
            url: URL + `/obtener/${id}/local`,
            method: 'Get',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + token,
            }
        })
            .then(response => {
                resolve(response?.data);
            })
            .catch(error => {
                reject(error.response.data);
            })

    });
};

//------------------------------------------------------------------------------Obtener detalle de la categoria
export const getDetalleCategoria = (id, token) => {

    return new Promise((resolve, reject) => {
        axios({
            url: URL + `/obtener/${id}/categoria`,
            method: 'Get',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + token,
            }
        })
            .then(response => {
                resolve(response?.data);
            })
            .catch(error => {
                reject(error.response.data);
            })

    });
};

//------------------------------------------------------------------------------add categoria
export const postAddCategoria = (body, token) => {

    return new Promise((resolve, reject) => {
        axios({
            url: URL + `/store/categoria`,
            method: 'Post',
            data: body,
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + token,
            }
        })
            .then(response => {
                resolve(response?.data);
            })
            .catch(error => {
                reject(error.response.data);
            })

    });
};

//------------------------------------------------------------------------------update categoria
export const postUpdateCategoria = (id, body, token) => {

    return new Promise((resolve, reject) => {
        axios({
            url: URL + `/update/${id}/categoria`,
            method: 'Post',
            data: body,
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + token,
            }
        })
            .then(response => {
                resolve(response?.data);
            })
            .catch(error => {
                reject(error.response.data);
            })

    });
};

//------------------------------------------------------------------------------update categoria
export const getBuscarCategoria = (token, body) => {

    return new Promise((resolve, reject) => {
        axios({
            // url: URL + `/filtrar/categoria?nombre=${search}`,
            url: URL + `/filtrar/categoria?nombre=${body?.titulo}&page=${body?.page}&per_page=${body?.per_page}`,
            method: 'Get',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + token,
            }
        })
            .then(response => {
                resolve(response?.data);
            })
            .catch(error => {
                reject(error.response.data);
            })

    });
};





//------------------------------------------------------------------------------ eliminar foto de promocion
export const postDeleteImagenPromocion = (token, id, idImagen) => {

    return new Promise((resolve, reject) => {
        axios({
            url: URL + `/promociones/${id}/imagenes/${idImagen}`,
            method: 'Post',
            data: {},
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + token,
            }
        })
            .then(response => {
                resolve(response?.data);
            })
            .catch(error => {
                reject(error.response.data);
            })

    });
};

//------------------------------------------------------------------------------ ordenar fotos de promocion
export const postUpdatePosicionImagen = (body, token, id) => {

    return new Promise((resolve, reject) => {
        axios({
            url: URL + `/promociones/${id}/imagenes/ordenar`,
            method: 'Post',
            data: body,
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + token,
            }
        })
            .then(response => {
                resolve(response?.data);
            })
            .catch(error => {
                reject(error.response.data);
            })

    });
};



//------------------------------------------------------------------------------obtener promocion
export const getObtenerPromocion = (id, token) => {

    return new Promise((resolve, reject) => {
        axios({
            // url: URL + `/obtener/${id}/promocion`,
            url: URL + `/promociones/${id}`,
            method: 'Get',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + token,
            }
        })
            .then(response => {
                resolve(response?.data?.data);
            })
            .catch(error => {
                reject(error.response.data);
            })

    });
};

//------------------------------------------------------------------------------update promocion
export const postUpdatePromocion = (id, body, token) => {

    return new Promise((resolve, reject) => {
        axios({
            url: URL + `/promociones/${id}`,
            method: 'Post',
            data: body,
            headers: {
                // No Content-Type on purpose: `body` is a FormData, so the browser
                // must set multipart/form-data together with its boundary. A manual
                // 'multipart/form-data' is sent WITHOUT a boundary and the backend
                // cannot parse the body at all.
                'Authorization': 'Bearer ' + token,
            }
        })
            .then(response => {
                resolve(response?.data);
            })
            .catch(error => {
                reject(error.response.data);
            })

    });
};





//------------------------------------------------------------------------------delete promocion
export const postDeletePromocion = (id, token) => {

    return new Promise((resolve, reject) => {
        axios({
            url: URL + `/promociones/delete/${id}`,
            method: 'Post',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + token,
            }
        })
            .then(response => {
                resolve(response?.data);
            })
            .catch(error => {
                reject(error.response.data);
            })

    });
};

//------------------------------------------------------------------------------add promocion
export const postAddPromocion = (body, token) => {

    return new Promise((resolve, reject) => {
        axios({
            // url: URL + `/store/promocion`,
            url: URL + `/promociones`,
            method: 'Post',
            data: body,
            headers: {
                // No Content-Type on purpose: `body` is a FormData carrying the
                // required `imagen` file. Setting 'application/json' makes axios
                // serialize the FormData to JSON, so the file never arrives and the
                // backend rejects the request with 422 "La imagen principal es
                // requerida". Let the browser send multipart/form-data with boundary.
                'Authorization': 'Bearer ' + token,
            }
        })
            .then(response => {
                resolve(response?.data);
            })
            .catch(error => {
                reject(error.response.data);
            })

    });
};

//------------------------------------------------------------------------------add eventos
export const postAddEvento = (body, token) => {

    return new Promise((resolve, reject) => {
        axios({
            url: URL + `/store/evento`,
            method: 'Post',
            data: body,
            headers: {
                'Authorization': 'Bearer ' + token,
            }
        })
            .then(response => {
                resolve(response?.data);
            })
            .catch(error => {
                reject(error.response.data);
            })

    });
};



//------------------------------------------------------------------------------add sorteos
export const postAddSorteo = (body, token) => {

    return new Promise((resolve, reject) => {
        axios({
            url: URL + `/store/sorteo`,
            method: 'Post',
            data: body,
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + token,
            }
        })
            .then(response => {
                resolve(response?.data);
            })
            .catch(error => {
                reject(error.response.data);
            })

    });
};


//------------------------------------------------------------------------------actualizar sorteo
export const postUpdateSorteo = (id, body, token) => {

    return new Promise((resolve, reject) => {
        axios({
            url: URL + `/update/${id}/sorteo`,
            method: 'Post',
            data: body,
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + token,
            }
        })
            .then(response => {
                resolve(response?.data);
            })
            .catch(error => {
                reject(error.response.data);
            })

    });
};

//------------------------------------------------------------------------------add local beneficio
export const postAddLocalBeneficio = (body, token) => {

    return new Promise((resolve, reject) => {
        axios({
            url: URL + `/store/beneficio-local`,
            method: 'Post',
            data: body,
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + token,
            }
        })
            .then(response => {
                resolve(response?.data);
            })
            .catch(error => {
                reject(error.response.data);
            })

    });
};

//------------------------------------------------------------------------------delete local beneficio
export const postDeleteLocalBeneficio = (body, token) => {

    return new Promise((resolve, reject) => {
        axios({
            url: URL + `/delete/beneficio-local`,
            method: 'Post',
            data: body,
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + token,
            }
        })
            .then(response => {
                resolve(response?.data);
            })
            .catch(error => {
                reject(error.response.data);
            })

    });
};

//------------------------------------------------------------------------------update local beneficio
export const postUpdateLocalBeneficio = (body, token) => {

    return new Promise((resolve, reject) => {
        axios({
            url: URL + `/update/local-beneficio-comentario`,
            method: 'Post',
            data: body,
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + token,
            }
        })
            .then(response => {
                resolve(response?.data);
            })
            .catch(error => {
                reject(error.response.data);
            })

    });
};

//------------------------------------------------------------------------------add beneficio
export const postAddBeneficio = (body, token) => {

    return new Promise((resolve, reject) => {
        axios({
            url: URL + `/store/beneficio`,
            method: 'Post',
            data: body,
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + token,
            }
        })
            .then(response => {
                resolve(response?.data);
            })
            .catch(error => {
                reject(error.response.data);
            })

    });
};




//------------------------------------------------------------------------------add locales
export const postAddLocal = (body, token) => {

    return new Promise((resolve, reject) => {
        axios({
            url: URL + `/store/local`,
            method: 'Post',
            data: body,
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + token,
            }
        })
            .then(response => {
                resolve(response?.data);
            })
            .catch(error => {
                reject(error.response.data);
            })

    });
};

//------------------------------------------------------------------------------update locales
export const postUpdateLocal = (body, id, token) => {

    return new Promise((resolve, reject) => {
        axios({
            url: URL + `/update/${id}/local`,
            method: 'Post',
            data: body,
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + token,
            }
        })
            .then(response => {
                resolve(response?.data);
            })
            .catch(error => {
                reject(error.response.data);
            })

    });
};

//------------------------------------------------------------------------------update cupon
export const postUpdateCupon = (body, id, token) => {

    return new Promise((resolve, reject) => {
        axios({
            url: URL + `/update/${id}/factura`,
            method: 'Post',
            data: body,
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + token,
            }
        })
            .then(response => {
                resolve(response?.data);
            })
            .catch(error => {
                reject(error.response.data);
            })

    });
};

//------------------------------------------------------------------------------filtrar locales
// export const getFiltrarLocales = (nombre, estado, categoriaId, token) => {
export const getFiltrarLocales = (token, body) => {

    return new Promise((resolve, reject) => {
        axios({
            // url: URL + `/filtrar/local?nombre=${nombre}&estado=${estado}&categoria=${categoriaId}`,
            url: URL + `/filtrar/local?nombre=${body?.nombre}&estado=${body?.estado}&categoria=${body?.categoriaId}&page=${body?.page}&per_page=${body?.per_page}`,
            method: 'Get',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + token,
            }
        })
            .then(response => {
                resolve(response?.data?.data);
            })
            .catch(error => {
                reject(error.response.data);
            })

    });
};



//------------------------------------------------------------------------------update eventos
export const postUpdateEvento = (body, id, token) => {

    return new Promise((resolve, reject) => {
        axios({
            url: URL + `/update/${id}/evento`,
            method: 'Post',
            data: body,
            headers: {
                'Authorization': 'Bearer ' + token,
            }
        })
            .then(response => {
                resolve(response?.data);
            })
            .catch(error => {
                reject(error.response.data);
            })

    });
};



//------------------------------------------------------------------------------update usuario
export const postUpdateUsuario = (body, id, token) => {

    return new Promise((resolve, reject) => {
        axios({
            url: URL + `/update/${id}/usuario-app`,
            method: 'Post',
            data: body,
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + token,
            }
        })
            .then(response => {
                resolve(response?.data);
            })
            .catch(error => {
                reject(error.response.data);
            })

    });
};

//------------------------------------------------------------------------------Obtener productos
export const getCategorias = (token, body) => {

    return new Promise((resolve, reject) => {
        axios({
            // url: URL + '/listar/categorias',
            url: URL + `/listar/categorias?titulo=${body?.titulo}&page=${body?.page}&per_page=${body?.per_page}`,
            method: 'Get',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + token,
            }
        })
            .then(response => {
                resolve(response.data);
            })
            .catch(error => {
                reject(error.response.data);
            })

    });
};


//------------------------------------------------------------------------------Obtener locales
export const getLocales = (token) => {

    return new Promise((resolve, reject) => {
        axios({
            url: URL + '/listar/locales',
            method: 'Get',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + token,
            }
        })
            .then(response => {
                resolve(response.data);
            })
            .catch(error => {
                reject(error.response.data);
            })

    });
};

//------------------------------------------------------------------------------Obtener filtro del local por RUC
export const getLocalesFiltrarRuc = (ruc, token) => {

    return new Promise((resolve, reject) => {
        axios({
            url: URL + `/operador/obsequios/facturas/locales/buscar?q=${ruc}`,
            method: 'Get',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + token,
            }
        })
            .then(response => {
                resolve(response.data?.data);
            })
            .catch(error => {
                reject(error.response.data);
            })

    });
};


//------------------------------------------------------------------------------Obtener filtro del local por nombre
export const getLocalesFiltrarPorNombre = (nombre, token) => {

    return new Promise((resolve, reject) => {
        axios({
            url: URL + `/filtrar/local?nombre=${nombre}`,
            method: 'Get',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + token,
            }
        })
            .then(response => {
                resolve(response.data?.data);
            })
            .catch(error => {
                reject(error.response.data);
            })

    });
};

//------------------------------------------------------------------------------Obtener filtro de nro de cupon
export const getFiltrosNroCupon = (token) => {

    return new Promise((resolve, reject) => {
        axios({
            url: URL + `/datos/filtros/nrocupon`,
            method: 'Get',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + token,
            }
        })
            .then(response => {
                resolve(response?.data);
            })
            .catch(error => {
                reject(error.response.data);
            })

    });
};




//------------------------------------------------------------------------------Buscar cupon
export const postBuscarCuponSorteo = (token, id, body) => {

    return new Promise((resolve, reject) => {
        axios({
            url: URL + `/sorteos/${id}/buscar-cupon-ganador`,
            method: 'Post',
            data: body,
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + token,
            }
        })
            .then(response => {
                resolve(response?.data);
            })
            .catch(error => {
                reject(error.response.data);
            })

    });
};

//------------------------------------------------------------------------------Obtener sorteos
// export const getSorteos = (titulo, promocion, publicacion, token) => {
export const getSorteos = (token, body) => {
    return new Promise((resolve, reject) => {
        axios({
            url: URL + `/filtrar/sorteo?titulo=${body.titulo}&estado_promocion=${body.estado_promocion}&estado_publicacion=${body.estado_publicacion}&page=${body.page}&per_page=${body.per_page}`,
            method: 'Get',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + token,
            }
        })
            .then(response => {
                resolve(response?.data?.data);
            })
            .catch(error => {
                reject(error.response.data);
            })

    });
};

//------------------------------------------------------------------------------Obtener productos
export const getProductos = (page, size) => {

    return new Promise((resolve, reject) => {
        axios({
            url: URL + '/api/auth/publicaciones/listar-publicacion/' + page + '/' + size,
            method: 'Get',
            headers: {
                'Content-Type': 'application/json',
            }
        })
            .then(response => {
                resolve(response.data);
            })
            .catch(error => {
                reject(error.response.data);
            })

    });
};

//------------------------------------------------------------------------------Obtener beneficios
export const getBeneficios = (token, body) => {

    return new Promise((resolve, reject) => {
        axios({
            // url: beneficios/listar?per_page=10&page=2&nombre=
            url: URL + `/beneficios/listar?per_page=${body?.per_page}&page=${body?.page}&nombre=${body?.nombre}`,
            method: 'Get',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + token,
            }
        })
            .then(response => {
                resolve(response?.data);
            })
            .catch(error => {
                reject(error.response.data);
            })

    });
};

//------------------------------------------------------------------------------Obtener los locales adheridos a un beneficio
export const getLocalesAdheridos = (id, token) => {

    return new Promise((resolve, reject) => {
        axios({
            url: URL + `/listar/${id}/beneficios-local-adherido`,
            method: 'Get',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + token,
            }
        })
            .then(response => {
                resolve(response?.data);
            })
            .catch(error => {
                reject(error.response.data);
            })

    });
};


//------------------------------------------------------------------------------filtrar clientes por su nombre
export const getFiltrarClientesCupon = (busqueda, token) => {

    return new Promise((resolve, reject) => {
        axios({
            url: URL + `/datos/filtros/nrocupon/clientes?term=${busqueda}`,
            method: 'Get',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + token,
            }
        })
            .then(response => {
                resolve(response?.data);
            })
            .catch(error => {
                reject(error.response.data);
            })

    });
};

//------------------------------------------------------------------------------obtener filtros de facturas
export const getFiltrosFacturas = (token) => {

    return new Promise((resolve, reject) => {
        axios({
            url: URL + `/datos/filtros/facturas`,
            method: 'Get',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + token,
            }
        })
            .then(response => {
                resolve(response?.data);
            })
            .catch(error => {
                reject(error.response.data);
            })

    });
};

//------------------------------------------------------------------------------filtrar usuarios por su nombre
export const getFiltrarUsuariosCupon = (busqueda, token) => {

    return new Promise((resolve, reject) => {
        axios({
            url: URL + `/datos/filtros/nrocupon/user?term=${busqueda}`,
            method: 'Get',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + token,
            }
        })
            .then(response => {
                resolve(response?.data);
            })
            .catch(error => {
                reject(error.response.data);
            })

    });
};








//------------------------------------------------------------------------------Actualizar contraseña del usuario
export const postUpdatePasswordUser = (token, body, id) => {

    return new Promise((resolve, reject) => {
        axios({
            url: URL + `/update/${id}/password`,
            method: 'Post',
            data: body,
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + token,
            }
        })
            .then(response => {
                resolve(response?.data);
            })
            .catch(error => {
                reject(error.response.data);
            })

    });
};

//------------------------------------------------------------------------------Obtener usuarios
export const getUsuarios = (token) => {

    return new Promise((resolve, reject) => {
        axios({
            url: URL + '/listar/usuarios-app',
            method: 'Get',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + token,
            }
        })
            .then(response => {
                resolve(response?.data);
            })
            .catch(error => {
                reject(error.response.data);
            })

    });
};


//------------------------------------------------------------------------------Obtener detalle del usuario
export const getUsuarioDetalleTransacciones = (token, body) => {

    return new Promise((resolve, reject) => {
        axios({
            url: URL + `/obtener/transacciones/${body?.id}/usuario-app`,
            method: 'Get',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + token,
            }
        })
            .then(response => {
                resolve(response?.data);
            })
            .catch(error => {
                reject(error.response.data);
            })

    });
};

//------------------------------------------------------------------------------Obtener detalle del usuario
export const getUsuarioDetalle = (token, body) => {

    return new Promise((resolve, reject) => {
        axios({
            // url: URL + `/obtener/${id}/usuario-app`,
            ///obtener/12318/usuario-app?canjes_per_page=5&canjes_page=1
            url: URL + `/obtener/${body?.id}/usuario-app?canjes_per_page=${body?.canjes_per_page}&canjes_page=${body?.canjes_page}`,
            method: 'Get',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + token,
            }
        })
            .then(response => {
                resolve(response?.data);
            })
            .catch(error => {
                reject(error.response.data);
            })

    });
};

//------------------------------------------------------------------------------filtrar usuarios
// export const getFiltrarUsuarios = (term, email, verificacion, estado, tipo, tester, token) => {
export const getFiltrarUsuarios = (token, body) => {
    return new Promise((resolve, reject) => {
        axios({
            url: URL + `/filtrar/usuario-app?term=${body.term}&email=${body.email}&verificacion=${body.verificacion}&estado=${body.estado}&tipo=${body.tipo}&tester=${body.tester}&page=${body.page}&per_page=${body.per_page}`,
            method: 'Get',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + token,
            }
        })
            .then(response => {
                resolve(response?.data);
            })
            .catch(error => {
                reject(error.response.data);
            })

    });
};


//------------------------------------------------------------------------------filtrar usuarios locales
export const getFiltrarUsuariosLocales = (token, body) => {
    return new Promise((resolve, reject) => {
        axios({
            ///listar/usuarios-locales?page=1&per_page=15&local_id&local=puma
            url: URL + `/listar/usuarios-locales?page=${body.page}&per_page=${body.per_page}&local_id=${body.local_id}&local=${body.local}`,
            method: 'Get',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + token,
            }
        })
            .then(response => {
                resolve(response?.data);
            })
            .catch(error => {
                reject(error.response.data);
            })

    });
};


//------------------------------------------------------------------------------filtrar gift card
export const getFiltrarGiftCard = (token, body) => {

    return new Promise((resolve, reject) => {
        axios({
            // url: URL + `/listar/giftcards?uso=${body.uso}&documento_comprador=${body.documento_comprador}&documento_beneficiado=${body.documento_beneficiado}&per_page=${body.per_page}&page=${body.page}&fecha_desde=${body.fecha_desde}&fecha_hasta=${body.fecha_hasta}`,
            url: URL + `/listar/giftcards?documento_beneficiado=${body.documento_beneficiado}&per_page=${body.per_page}&page=${body.page}&fecha_desde=${body.fecha_desde}&fecha_hasta=${body.fecha_hasta}`,
            method: 'Get',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + token,
            }
        })
            .then(response => {
                resolve(response?.data?.data);
            })
            .catch(error => {
                reject(error.response.data);
            })

    });
};


//------------------------------------------------------------------------------detalle gift card
export const getDetalleGiftCard = (token, id) => {

    return new Promise((resolve, reject) => {
        axios({
            url: URL + `/detalles/${id}/giftcards`,
            method: 'Get',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + token,
            }
        })
            .then(response => {
                resolve(response?.data?.data);
            })
            .catch(error => {
                reject(error.response.data);
            })

    });
};


//------------------------------------------------------------------------------reasignar gift card
export const postReasingarGiftCard = (token, body) => {

    return new Promise((resolve, reject) => {
        axios({
            url: URL + `/reasignar/${body?.giftcard_id}/giftcards`,
            method: 'Post',
            data: body,
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + token,
            }
        })
            .then(response => {
                resolve(response?.data?.data);
            })
            .catch(error => {
                reject(error.response.data);
            })

    });
};


//------------------------------------------------------------------------------filtrar cupones
export const getFiltrarCupones = (
    sorteos, fecha_desde_factura, fecha_hasta_factura, fecha_desde_procesamiento, fecha_hasta_procesamiento,
    local, cliente, usuario, procesado_por, cupones_anulados, token
) => {
    // export const getFiltrarCupones = (token, body) => {

    return new Promise((resolve, reject) => {
        axios({
            url: URL + `/filtrar/factura?sorteos=${sorteos}&fecha_desde_factura=${fecha_desde_factura}&fecha_hasta_factura=${fecha_hasta_factura}&fecha_desde_procesamiento=${fecha_desde_procesamiento}&fecha_hasta_procesamiento=${fecha_hasta_procesamiento}&local=${local}&cliente=${cliente}&usuario=${usuario}&procesado_por=${procesado_por}&cupones_anulados=${cupones_anulados}`,
            // url: URL + `/filtrar/factura?sorteos=${body.sorteos}&fecha_desde_factura=${body.fecha_desde_factura}&fecha_hasta_factura=${body.fecha_hasta_factura}&fecha_desde_procesamiento=${body.fecha_desde_procesamiento}&fecha_hasta_procesamiento=${body.fecha_hasta_procesamiento}&local=${body.local}&cliente=${body.cliente}&usuario=${body.usuario}&procesado_por=${body.procesado_por}&cupones_anulados=${body.cupones_anulados}&page=${body.page}&per_page=${body.per_page}`,
            method: 'Get',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + token,
            }
        })
            .then(response => {
                resolve(response?.data);
            })
            .catch(error => {
                reject(error.response.data);
            })

    });
};


//------------------------------------------------------------------------------filtrar eventos
export const getFiltrarEventos = (token, body) => {

    return new Promise((resolve, reject) => {
        axios({
            // url: URL + `/filtrar/evento?titulo=${titulo}&estado=${estado}`,
            url: URL + `/filtrar/evento?titulo=${body.titulo}&estado=${body.estado}&page=${body.page}&per_page=${body.per_page}`,
            method: 'Get',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + token,
            }
        })
            .then(response => {
                resolve(response?.data?.data);
            })
            .catch(error => {
                reject(error.response.data);
            })

    });
};

//------------------------------------------------------------------------------filtros de reporte
export const getFiltroReporte = (token) => {

    return new Promise((resolve, reject) => {
        axios({
            url: URL + `/create/reporte/filtros`,
            method: 'Get',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + token,
            }
        })
            .then(response => {
                const payload = response?.data || {};
                const filtros = payload?.data || {};
                const localesRaw = filtros?.locales || {};
                const tipos_de_reporteRaw = filtros?.tipos_de_reporte || {};

                const locales = Array.isArray(localesRaw)
                    ? localesRaw
                    : Object.entries(localesRaw).map(([id, nombre]) => ({
                        id: Number.isNaN(Number(id)) ? id : Number(id),
                        nombre,
                    }));

                const tipos_de_reporte = Array.isArray(tipos_de_reporteRaw)
                    ? tipos_de_reporteRaw
                    : Object.entries(tipos_de_reporteRaw).map(([id, nombre], index) => ({
                        // id: Number.isNaN(Number(id)) ? id : Number(id),
                        id: index + 1, // Asignar un ID incremental basado en el índice
                        nombre,
                    }));

                resolve({
                    ...payload,
                    data: {
                        ...filtros,
                        locales,
                        tipos_de_reporte,
                    },
                });
            })
            .catch(error => {
                reject(error.response.data);
            })

    });
};


//------------------------------------------------------------------------------filtrar promociones
export const getFiltrarPromociones = (token, body) => {

    return new Promise((resolve, reject) => {
        axios({
            // /promociones/listar is the admin route. A plain GET /promociones belongs
            // to the mobile app (app_token middleware) and answers 403.
            url: URL + `/promociones/listar?titulo=${body.titulo}&estado=${body.estado}&page=${body.page}&per_page=${body.per_page}`,
            method: 'Get',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + token,
            }
        })
            .then(response => {
                resolve(response?.data);
            })
            .catch(error => {
                reject(error.response.data);
            })

    });
};


// //------------------------------------------------------------------------------filtrar promociones
// export const getFiltrarPromociones = (titulo, estado, token) => {

//     return new Promise((resolve, reject) => {
//         axios({
//             url: URL + `/filtrar/promocion?titulo=${titulo}&estado=${estado}`,
//             method: 'Get',
//             headers: {
//                 'Content-Type': 'application/json',
//                 'Authorization': 'Bearer ' + token,
//             }
//         })
//             .then(response => {
//                 resolve(response?.data);
//             })
//             .catch(error => {
//                 reject(error.response.data);
//             })

//     });
// };


//------------------------------------------------------------------------------filtrar facturas
// export const getFiltrarFacturas = (
//     fecha_desde_factura, fecha_hasta_factura, cliente, local, estado, procesado_por,
//     nro_factura, procesado_por_user, monto_desde, monto_hasta, token
// ) => {
export const getFiltrarFacturas = (token, body) => {

    return new Promise((resolve, reject) => {
        axios({
            // url: URL + `/filtrar/factura/factura?fecha_desde=${fecha_desde_factura}&fecha_hasta=${fecha_hasta_factura}&cliente=${cliente}&local=${local}&estado=${estado}&procesado_por=${procesado_por}&nro_factura=${nro_factura}&procesado_por_user=${procesado_por_user}&monto_desde=${monto_desde}&monto_hasta=${monto_hasta}`,
            url: URL + `/listar/factura/factura?fecha_desde=${body.fecha_desde_factura}&fecha_hasta=${body.fecha_hasta_factura}&cliente=${body.cliente}&local=${body.local}&estado=${body.estado}&procesado_por=${body.procesado_por}&nro_factura=${body.nro_factura}&procesado_por_user=${body.procesado_por_user}&monto_desde=${body.monto_desde}&monto_hasta=${body.monto_hasta}&page=${body.page}&per_page=${body.per_page}`,
            method: 'Get',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + token,
            }
        })
            .then(response => {
                resolve(response?.data);
            })
            .catch(error => {
                reject(error.response.data);
            })

    });
};


//------------------------------------------------------------------------------Obtener detalle de la factura
export const getDetalleFactura = (token, id) => {

    return new Promise((resolve, reject) => {
        axios({
            url: URL + `/detalles/${id}/factura`,
            method: 'Get',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + token,
            }
        })
            .then(response => {
                resolve(response?.data);
            })
            .catch(error => {
                reject(error.response.data);
            })

    });
};


//------------------------------------------------------------------------------filtrar facturas pendientes
export const getFiltrarFacturasPendientes = (fecha_desde_factura, fecha_hasta_factura, cliente, token) => {

    return new Promise((resolve, reject) => {
        axios({
            url: URL + `/filtrar/factura/pendiente?created_from=${fecha_desde_factura}&created_to=${fecha_hasta_factura}&usuario=${cliente}`,
            method: 'Get',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + token,
            }
        })
            .then(response => {
                resolve(response?.data);
            })
            .catch(error => {
                reject(error.response.data);
            })

    });
};




//------------------------------------------------------------------------------detalle de producto
export const postDetalleProducto = (id) => {

    return new Promise((resolve, reject) => {
        axios({
            url: URL + '/api/auth/publicaciones/obtener-publicacion/' + id,
            method: 'Get',
            headers: {
                'Content-Type': 'application/json',
            }
        })
            .then(response => {
                resolve(response.data);
            })
            .catch(error => {
                reject(error.response.data);
            })

    });
};


//------------------------------------------------------------------------------obtener obsequio detalle factura
export const getDetalleFacturaObsequio = (token, id) => {

    return new Promise((resolve, reject) => {
        axios({
            url: URL + `/operador/obsequios/facturas/${id}`,
            method: 'Get',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + token,
            }
        })
            .then(response => {
                resolve(response.data);
            })
            .catch(error => {
                reject(error.response.data);
            })

    });
};



//------------------------------------------------------------------------------obtener obsequios vigentes
export const getObsequioVigente = (token) => {

    return new Promise((resolve, reject) => {
        axios({
            url: URL + '/obtener/obsequios/vigentes',
            method: 'Get',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + token,
            }
        })
            .then(response => {
                resolve(response.data);
            })
            .catch(error => {
                reject(error.response.data);
            })

    });
};



//------------------------------------------------------------------------------filtrar obsequios
export const getFiltrarObsequiosFacturas = (token, body) => {
    return new Promise((resolve, reject) => {
        axios({
            url: URL + `/operador/obsequios/facturas/buscar?ci=${body.ci}&obsequio_id=${body.obsequio_id}&page=${body.page}&per_page=${body.per_page}`,
            method: 'Get',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + token,
            }
        })
            .then(response => {
                resolve(response?.data);
            })
            .catch(error => {
                reject(error.response.data);
            })

    });
};



//------------------------------------------------------------------------------filtrar obsequios
export const getFiltrarObsequios = (token, body) => {
    return new Promise((resolve, reject) => {
        axios({
            // url: URL + /obsequios?per_page=10&page=1&titulo
            url: URL + `/obsequios?per_page=${body.per_page}&page=${body.page}&titulo=${body.titulo}`,
            method: 'Get',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + token,
            }
        })
            .then(response => {
                resolve(response?.data);
            })
            .catch(error => {
                reject(error.response.data);
            })

    });
};

export const getObsequiosListar = (token, body) => {

    return new Promise((resolve, reject) => {
        axios({
            url: URL + `/obsequios/listar/facturas/listado?fecha_desde=${body.fecha_desde}&fecha_hasta=${body.fecha_hasta}&local_id=${body.local_id}&obsequio_id=${body.obsequio_id}&nro_factura=${body.nro_factura}&page=${body.page}&per_page=${body.per_page}`,
            method: 'Get',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + token,
            }
        })
            .then(response => {
                resolve(response?.data);
            })
            .catch(error => {
                reject(error.response.data);
            })

    });
};



//------------------------------------------------------------------------------rechazar estado de la factura obsequio
export const postRechazarFacturaObsequio = (token, body, id) => {

    return new Promise((resolve, reject) => {
        axios({
            url: URL + `/obsequios/facturas/${id}/rechazar`,
            method: 'Post',
            data: body,
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + token,
            }
        })
            .then(response => {
                resolve(response?.data);
            })
            .catch(error => {
                reject(error.response.data);
            })

    });
};


//------------------------------------------------------------------------------actualizar estado de la factura obsequio
export const putFacturaObsequio = (token, body, id) => {

    return new Promise((resolve, reject) => {
        axios({
            url: URL + `/operador/obsequios/facturas/${id}/revisar`,
            method: 'Put',
            data: body,
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + token,
            }
        })
            .then(response => {
                resolve(response?.data);
            })
            .catch(error => {
                reject(error.response.data);
            })

    });
};

//------------------------------------------------------------------------------aprobar estado de la factura obsequio
export const postAprobarFacturaObsequio = (token, body, id) => {

    return new Promise((resolve, reject) => {
        axios({
            url: URL + `/operador/obsequios/facturas/${id}/aprobar`,
            method: 'Post',
            data: body,
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + token,
            }
        })
            .then(response => {
                resolve(response?.data);
            })
            .catch(error => {
                reject(error.response.data);
            })

    });
};


//------------------------------------------------------------------------------confirmar canje de la factura obsequio
export const postConfirmarCanjeObsequio = (token, body, id) => {

    return new Promise((resolve, reject) => {
        axios({
            url: URL + `/operador/obsequios/canjes/factura/${id}/canjear`,
            method: 'Post',
            data: body,
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + token,
            }
        })
            .then(response => {
                resolve(response?.data);
            })
            .catch(error => {
                reject(error.response.data);
            })

    });
};



//------------------------------------------------------------------------------add obsequio
export const postAddObsequio = (token, body) => {

    return new Promise((resolve, reject) => {
        axios({
            url: URL + `/obsequios`,
            method: 'Post',
            data: body,
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + token,
            }
        })
            .then(response => {
                resolve(response?.data);
            })
            .catch(error => {
                reject(error.response.data);
            })

    });
};

//------------------------------------------------------------------------------update obsequio
export const postUpdateObsequio = (token, id, body) => {

    return new Promise((resolve, reject) => {
        axios({
            url: URL + `/obsequios/${id}`,
            method: 'Post',
            data: body,
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + token,
            }
        })
            .then(response => {
                resolve(response?.data);
            })
            .catch(error => {
                reject(error.response.data);
            })

    });
};

//------------------------------------------------------------------------------detalle obsequio
export const getDetalleObsequio = (token, id) => {

    return new Promise((resolve, reject) => {
        axios({
            url: URL + `/obsequios/${id}`,
            method: 'Get',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + token,
            }
        })
            .then(response => {
                resolve(response?.data);
            })
            .catch(error => {
                reject(error.response.data);
            })

    });
};


//------------------------------------------------------------------------------activar obsequio
export const postActivarObsequio = (token, id) => {

    return new Promise((resolve, reject) => {
        axios({
            url: URL + `/obsequios/${id}/activar`,
            method: 'Post',
            data: {},
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + token,
            }
        })
            .then(response => {
                resolve(response?.data);
            })
            .catch(error => {
                reject(error.response.data);
            })

    });
};

//------------------------------------------------------------------------------desactivar obsequio
export const postDesactivarObsequio = (token, id) => {

    return new Promise((resolve, reject) => {
        axios({
            url: URL + `/obsequios/${id}/desactivar`,
            method: 'Post',
            data: {},
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + token,
            }
        })
            .then(response => {
                resolve(response?.data);
            })
            .catch(error => {
                reject(error.response.data);
            })

    });
};



//------------------------------------------------------------------------------Obtener gift card reporte
export const postGiftCardReporte = (token, body) => {

    return new Promise((resolve, reject) => {
        axios({
            url: URL + `/reporte/giftcard`,
            method: 'Post',
            data: body,
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + token,
            }
        })
            .then(response => {
                resolve(response?.data);
            })
            .catch(error => {
                reject(error.response.data);
            })

    });
};

//------------------------------------------------------------------------------Obtener reporte paseo plus
export const postReportePaseoPlus = (token, body) => {

    return new Promise((resolve, reject) => {
        axios({
            url: URL + `/generar/reporte/vales`,
            method: 'Post',
            data: body,
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + token,
            }
        })
            .then(response => {
                resolve(response?.data);
            })
            .catch(error => {
                reject(error.response.data);
            })

    });
};

//------------------------------------------------------------------------------Obtener reporte caja
export const postReporteCaja = (token, body) => {

    return new Promise((resolve, reject) => {
        axios({
            url: URL + `/reporte-caja/pdf`,
            method: 'Post',
            data: body,
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + token,
            }
        })
            .then(response => {
                resolve(response?.data);
            })
            .catch(error => {
                reject(error.response.data);
            })

    });
};

//------------------------------------------------------------------------------
// Obtener reporte cierre de caja ( Giftcard API )
export const postCierreDeCaja = (token, body) => {

    return new Promise((resolve, reject) => {
        axios({
            url: URL + `/reporte/giftcard`,
            method: 'Post',
            data: {
                ...body,
                tipo_reporte: "cierre_de_caja",
            },
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + token,
            }
        })
            .then(response => {
                resolve(response?.data);
            })
            .catch(error => {
                reject(error.response.data);
            })

    });
};



//------------------------------------------------------------------------------filtrar locales para gift card
export const getFiltrarLocalesGiftCard = (token, body) => {

    return new Promise((resolve, reject) => {
        axios({
            url: URL + `/empresas/listar?buscar=${body?.nombre}&page=${body?.page}&per_page=${body?.per_page}`,
            method: 'Get',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + token,
            }
        })
            .then(response => {
                resolve(response?.data?.data);
            })
            .catch(error => {
                reject(error.response.data);
            })

    });
};


//------------------------------------------------------------------------------detalle local gift card
export const getDetalleLocalGiftCard = (token, id) => {

    return new Promise((resolve, reject) => {
        axios({
            url: URL + `/empresas/${id}`,
            method: 'Get',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + token,
            }
        })
            .then(response => {
                resolve(response?.data?.data);
            })
            .catch(error => {
                reject(error.response.data);
            })

    });
};



//------------------------------------------------------------------------------ crear local gift card
export const postCrearLocalGiftCard = (token, body) => {

    return new Promise((resolve, reject) => {
        axios({
            url: URL + `/empresas`,
            method: 'Post',
            data: body,
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + token,
            }
        })
            .then(response => {
                resolve(response?.data);
            })
            .catch(error => {
                reject(error.response.data);
            })

    });
};


//------------------------------------------------------------------------------ actualizar local gift card
export const postUpdateLocalGiftCard = (token, body, id) => {

    return new Promise((resolve, reject) => {
        axios({
            url: URL + `/empresas/${id}`,
            method: 'Post',
            data: body,
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + token,
            }
        })
            .then(response => {
                resolve(response?.data);
            })
            .catch(error => {
                reject(error.response.data);
            })

    });
};




//------------------------------------------------------------------------------filtrar compras 
export const getFiltrarCompras = (token, body) => {

    return new Promise((resolve, reject) => {
        axios({
            url: URL + `/empresas/listar/empresa?buscar=${body?.buscar}&empresa_id=${body?.empresa_id}&fecha_desde=${body?.fecha_desde}&fecha_hasta=${body?.fecha_hasta}&per_page=${body?.per_page}&page=${body?.page}`,
            method: 'Get',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + token,
            }
        })
            .then(response => {
                // Se retorna el payload completo para poder usar datos + metadatos de paginacion.
                resolve(response?.data);
            })
            .catch(error => {
                reject(error.response.data);
            })

    });
};

//------------------------------------------------------------------------------crear compra 
export const postCrearCompra = (token, body) => {

    return new Promise((resolve, reject) => {
        axios({
            url: URL + `/empresas/compra/empresa`,
            method: 'Post',
            data: body,
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + token,
            }
        })
            .then(response => {
                resolve(response?.data?.data);
            })
            .catch(error => {
                reject(error.response.data);
            })

    });
};















//------------------------------------------------------------------------------detalle banner
export const getDetalleBanner = (token, id) => {

    return new Promise((resolve, reject) => {
        axios({
            url: URL + `/banners/${id}`,
            method: 'Get',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + token,
            }
        })
            .then(response => {
                resolve(response?.data?.data);
            })
            .catch(error => {
                reject(error.response.data);
            })

    });
};


//------------------------------------------------------------------------------ actualizar banner
export const postUpdateBanner = (token, body, id) => {

    return new Promise((resolve, reject) => {
        axios({
            url: URL + `/banners/${id}`,
            method: 'Post',
            data: body,
            headers: {
                'Authorization': 'Bearer ' + token,
            }
        })
            .then(response => {
                resolve(response?.data);
            })
            .catch(error => {
                reject(error.response.data);
            })

    });
};



//------------------------------------------------------------------------------crear banner 
export const postCrearBanner = (token, body) => {

    return new Promise((resolve, reject) => {
        axios({
            url: URL + `/banners`,
            method: 'Post',
            data: body,
            headers: {
                'Authorization': 'Bearer ' + token,
            }
        })
            .then(response => {
                resolve(response?.data?.data);
            })
            .catch(error => {
                reject(error.response.data);
            })

    });
};
//------------------------------------------------------------------------------Obtener banners
export const getBanners = (token, body) => {

    return new Promise((resolve, reject) => {
        axios({
            url: URL + `/banners?titulo=${body?.titulo}&per_page=${body?.per_page}&page=${body?.page}`,
            method: 'Get',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + token,
            }
        })
            .then(response => {
                resolve(response?.data);
            })
            .catch(error => {
                reject(error.response.data);
            })

    });
};





























//------------------------------------------------------------------------------detalle vale
export const getDetalleVale = (token, id) => {

    return new Promise((resolve, reject) => {
        axios({
            url: URL + `/vale-promociones/${id}`,
            method: 'Get',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + token,
            }
        })
            .then(response => {
                resolve(response?.data?.data);
            })
            .catch(error => {
                reject(error.response.data);
            })

    });
};

//------------------------------------------------------------------------------ actualizar vale
export const postUpdateVale = (token, body, id) => {

    return new Promise((resolve, reject) => {
        axios({
            url: URL + `/vale-promociones/${id}`,
            method: 'Post',
            data: body,
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + token,
            }
        })
            .then(response => {
                resolve(response?.data);
            })
            .catch(error => {
                reject(error.response.data);
            })

    });
};

//------------------------------------------------------------------------------crear vale
export const postCrearVale = (token, body) => {

    return new Promise((resolve, reject) => {
        axios({
            url: URL + `/vale-promociones`,
            method: 'Post',
            data: body,
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + token,
            }
        })
            .then(response => {
                resolve(response?.data?.data);
            })
            .catch(error => {
                reject(error.response.data);
            })

    });
};

//------------------------------------------------------------------------------Obtener vales
export const getVales = (token, body) => {

    return new Promise((resolve, reject) => {
        axios({
            url: URL + `/vale-promociones?nombre=${body?.titulo}&per_page=${body?.per_page}&page=${body?.page}`,
            method: 'Get',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + token,
            }
        })
            .then(response => {
                resolve(response?.data);
            })
            .catch(error => {
                reject(error.response.data);
            })

    });
};











//------------------------------------------------------------------------------crear notificacion
export const postCrearNotificacion = (token, body) => {

    return new Promise((resolve, reject) => {
        axios({
            url: URL + `/notificaciones/store`,
            method: 'Post',
            data: body,
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + token,
            }
        })
            .then(response => {
                resolve(response?.data?.data);
            })
            .catch(error => {
                reject(error.response.data);
            })

    });
};

//------------------------------------------------------------------------------Obtener notificaciones
export const getNotificaciones = (token, body) => {

    return new Promise((resolve, reject) => {
        axios({
            url: URL + `/notificaciones/listar?nombre=${body?.titulo}&per_page=${body?.per_page}&page=${body?.page}`,
            method: 'Get',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + token,
            }
        })
            .then(response => {
                resolve(response?.data);
            })
            .catch(error => {
                reject(error.response.data);
            })

    });
};



















//------------------------------------------------------------------------------Obtener detalle del cupon
export const getDetalleCupon = (token, id) => {

    return new Promise((resolve, reject) => {
        axios({
            url: URL + `/cupones/${id}`,
            method: 'Get',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + token,
            }
        })
            .then(response => {
                resolve(response?.data);
            })
            .catch(error => {
                reject(error.response.data);
            })

    });
};
//------------------------------------------------------------------------------Obtener cupones
export const getCupones = (token, body) => {

    return new Promise((resolve, reject) => {
        axios({
            // /sorteo-cupones?sorteo_id=&ci=&local_id=&fecha_procesamiento_desde=&fecha_procesamiento_hasta=&fecha_factura_desde=2025-12-01&fecha_factura_hasta=2026-02-28&per_page=10&page=1
            url: URL + `/sorteo-cupones?sorteo_id=${body?.sorteo_id}&ci=${body?.ci}&local_id=${body?.local_id}&fecha_procesamiento_desde=${body?.fecha_procesamiento_desde}&fecha_procesamiento_hasta=${body?.fecha_procesamiento_hasta}&fecha_factura_desde=${body?.fecha_factura_desde}&fecha_factura_hasta=${body?.fecha_factura_hasta}&per_page=${body?.per_page}&page=${body?.page}`,
            method: 'Get',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + token,
            }
        })
            .then(response => {
                resolve(response?.data);
            })
            .catch(error => {
                reject(error.response.data);
            })

    });
};








//------------------------------------------------------------------------------Obtener detalle del beneficio
export const getDetalleBeneficio = (token, id) => {

    return new Promise((resolve, reject) => {
        axios({
            url: URL + `/beneficios/show/${id}`,
            method: 'Get',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + token,
            }
        })
            .then(response => {
                resolve(response?.data);
            })
            .catch(error => {
                reject(error.response.data);
            })

    });
};


//------------------------------------------------------------------------------crear beneficio
export const postCrearBeneficio = (token, body) => {

    return new Promise((resolve, reject) => {
        axios({
            url: URL + `/beneficios/store`,
            method: 'Post',
            data: body,
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + token,
            }
        })
            .then(response => {
                resolve(response?.data?.data);
            })
            .catch(error => {
                reject(error.response.data);
            })

    });
};


//------------------------------------------------------------------------------actualizar beneficio
export const postUpdateBeneficio = (token, body, id) => {

    return new Promise((resolve, reject) => {
        axios({
            url: URL + `/beneficios/update/${id}`,
            method: 'Post',
            data: body,
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + token,
            }
        })
            .then(response => {
                resolve(response?.data?.data);
            })
            .catch(error => {
                reject(error.response.data);
            })

    });
};



//------------------------------------------------------------------------------Obtener dasboard home
export const getHome = (token, body) => {

    return new Promise((resolve, reject) => {
        axios({
            ////dashboard?desde=2025-01-01&hasta=2025-12-31
            url: URL + `/dashboard?desde=${body?.desde}&hasta=${body?.hasta}`,
            method: 'Get',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + token,
            }
        })
            .then(response => {
                resolve(response?.data);
            })
            .catch(error => {
                reject(error.response.data);
            })

    });
};




//------------------------------------------------------------------------------Obtener reporte obsequios
export const getReporteObsequios = (token, id) => {

    return new Promise((resolve, reject) => {
        axios({
            url: URL + `/obsequios/${id}/reporte-excel`,
            method: 'Get',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + token,
            }
        })
            .then(response => {
                resolve(response.data);
            })
            .catch(error => {
                reject(error.response.data);
            })

    });
};